import React, { useState, useEffect, useCallback, useMemo } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import moment from "moment";
import { http } from "../helper";
import {
  capitalizeFirstLetter,
  dateformatwithuktime,
} from "../utilityfunctions";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const customStyles = {
  rows: {
    style: {
      minHeight: "25px",
    },
  },
  headCells: {
    style: {
      padding: "8px", // override the cell padding for head cells
    },
  },
  cells: {
    style: {
      padding: "8px", // override the cell padding for data cells
    },
  },
};

const paginationComponentOptions = {
  rowsPerPageText: "",
  rangeSeparatorText: "",
  selectAllRowsItem: true,
  selectAllRowsItemText: "",
  noRowsPerPage: "",
};

const conditionalRowStyles = [
  {
    when: (row) => moment(row.ToDate, "YYYY-MM-DD").isBefore(moment(), "day"),
    style: {
      backgroundColor: "#ffcccc !important", // Light red for expired rows
      color: "#000", // Optional: Adjust text color for visibility
    },
  },
];

const Promotions = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [promotionslist, setPromotionslist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [freeproductpdfvalue, setFreeproductpdfvalue] = useState("");

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promotions")
  ) {
    window.location.href = "/unauthorized";
  }

  const getPromotionslist = useCallback(() => {
    let URL = BaseUrl + "admin/listpromotions";
    http
      .get(URL)
      .then((response) => {
        // Sort by sortOrder
        let responseData = response.data.data;
        responseData.sort((a, b) => {
          let fromDateA = new Date(a.FromDate);
          let fromDateB = new Date(b.FromDate);
          let toDateA = new Date(a.ToDate);
          let toDateB = new Date(b.ToDate);
          // Sort by fromDate first
          if (fromDateA - fromDateB !== 0) {
            return fromDateA - fromDateB;
          }
          // If fromDate is the same, sort by toDate
          return toDateA - toDateB;
        });
        setPromotionslist(responseData);
        setLoading(false);
        setTemplist(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const editPromotionDetails = useCallback((editid) => {
    window.location.href = `/promotions/edit/${editid}`;
  }, []);

  const deletePromotion = useCallback((value) => {
    setVisibleAlert(true);
    setFreeproductpdfvalue(value);
  }, []);

  const deletePromotionsdetails = useCallback(() => {
    let URL = BaseUrl + `admin/deletepromotion/${freeproductpdfvalue._id}`;
    http
      .delete(URL)
      .then(async (response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [freeproductpdfvalue]);

  const alertPopupclose = useCallback(() => {
    setVisibleAlert(false);
    setFreeproductpdfvalue("");
  }, []);

  const addPromotion = useCallback(() => {
    window.location.href = "/promotions/add";
  }, []);

  const filterData = useCallback(
    (value) => {
      let accoun = templist;
      const lowercasedValue = value.toLowerCase().trim();
      let result = [];
      if (lowercasedValue.length > 0) {
        accoun.forEach((item) => {
          if (item.Title.toString().toLowerCase().includes(lowercasedValue)) {
            result.push(item);
          }
        });
        setPromotionslist(result);
      } else {
        setPromotionslist(accoun);
      }
    },
    [templist],
  );

  const handleReset = useCallback(() => {
    setSearchTextVal("");
    setPromotionslist(templist);
  }, [templist]);

  const handleChange = useCallback(
    (value) => {
      setSearchTextVal(value);
      filterData(value);
    },
    [filterData],
  );

  useEffect(() => {
    getPromotionslist();
  }, []);

  const columns = useMemo(
    () => [
      {
        name: t("title_txt"),
        selector: (row) => row.Title,
        sortable: true,
      },
      {
        name: t("category_txt"),
        selector: (row) =>
          row.Category === "pasta" || row.Category === "burrito"
            ? t("pasta_txt")
            : row.Category.charAt(0).toUpperCase() + row.Category.slice(1),
        sortable: true,
      },
      {
        name: t("status_txt"),
        selector: (row) => capitalizeFirstLetter(row.Status),
        sortable: true,
      },
      {
        name: t("from_date_txt"),
        selector: (row) =>
          row.FromDate ? moment(row.FromDate).format("DD-MM-YYYY") : "-",
        sortable: true,
      },
      {
        name: t("to_date_txt"),
        selector: (row) =>
          row.ToDate ? moment(row.ToDate).format("DD-MM-YYYY") : "-",
        sortable: true,
      },
      {
        name: t("actions_txt"),
        selector: (row) => {
          const canEdit = canAction("manage_promotions", "edit");
          return (
            <div style={{ display: "flex" }}>
              <a
                className="editbtn button title-tooltip title-up"
                data-title={canEdit ? t("edit_txt") : t("view_txt")}
                style={{ color: "white" }}
                onClick={() => editPromotionDetails(row._id)}
              >
                <i
                  className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                  aria-hidden="true"
                ></i>
              </a>
              {canAction("manage_promotions", "delete") && (
                <a
                  className="editbtn button title-tooltip title-up"
                  data-title={t("delete_txt")}
                  style={{ color: "white" }}
                  onClick={() => deletePromotion(row)}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              )}
            </div>
          );
        },
        sortable: false,
      },
    ],
    [editPromotionDetails, deletePromotion],
  );

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("promotion_banner_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-ord-btn"
                      onClick={(e) => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_promotions", "add") && (
                    <div className="add-holidaybtn">
                      <button className="addbtn" onClick={addPromotion}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow promotions-data-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_promo_bannar_txt")}
                      </div>
                    }
                    data={promotionslist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                    conditionalRowStyles={conditionalRowStyles} // Apply row highlighting
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert === true && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    onClick={deletePromotionsdetails}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Promotions;
